import request from '@/services/request';

const ROUTE = 'search';

export default {
  creators: (query, page, limit) => request
    .get(`${ROUTE}/creators/new`, { params: { query, page, limit } }),
  content: (query, page, limit) => request
    .get(`${ROUTE}/content`, { params: { query, page, limit } }),
};
